import { Injectable } from '@angular/core';
import { assign, cloneDeep } from 'lodash-es';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { users as usersData } from 'app/mock-api/common/users/data';

@Injectable({
    providedIn: 'root'
})
export class UsersMockApi
{
    private _users: any = usersData;

    /**
     * Constructor
     */
    constructor(private _fuseMockApiService: FuseMockApiService)
    {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void
    {
        // -----------------------------------------------------------------------------------------------------
        // @ User - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/users')
            .reply(() => {

                // Clone the contacts
                const users = cloneDeep(this._users);

                users.sort((a, b) => a.firstName.localeCompare(b.firstName));

                // Return the response
                return [200, users];
            });

        // -----------------------------------------------------------------------------------------------------
        // @ User - PATCH
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onPatch('api/users')
            .reply(({request}) => {

                // Get the user mock-api
                const user = cloneDeep(request.body.user);

                // Update the user mock-api
                this._users = assign({}, this._users, user);

                // Return the response
                return [200, cloneDeep(this._users)];
            });
    }
}
